import React, { useRef, useState } from 'react';
import { Formik, Form } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import styles from './styles.module.css';
import { getCreating } from '../redux/selectors';
import { update_product_group } from '../redux/reducers';
import { FileUploadToCloud } from '@app/services/fileUploadService';

const UpdateGroup = ({ group, onClose }) => {
  const [productImage, setProductImage] = useState(
    group?.image ? group?.image : null
  );

  const loading = useSelector(getCreating);
  const [creating, setCreating] = useState(false);
  const dispatch = useDispatch();
  let data = {
    name: group?.name,
    description: group?.description
  };

  const submit = async (doc) => {
    setCreating(true);
    try {
      const response = await FileUploadToCloud(productImage);
      let data = {
        ...doc,
        image: response.secure_url
      };
      dispatch(update_product_group({ id: group?._id, data }));
      setTimeout(() => {
        onClose();
      }, 1500);
    } catch {
    } finally {
      setCreating(false);
    }
  };

  const imgRef = useRef();

  const handleOpenImage = () => {
    imgRef.current.click();
  };

  const handlePickImage = (e) => {
    setProductImage(e.target.files[0]);
  };

  return (
    <Formik initialValues={data} onSubmit={submit}>
      {({ handleChange, values }) => (
        <Form className={styles.container}>
          <div className={styles.label}>Name</div>
          <input
            type="text"
            placeholder="name"
            name="name"
            value={values.name}
            onChange={handleChange}
          />

          <div className={styles.label}>Description</div>
          <textarea
            name="description"
            placeholder="description"
            onChange={handleChange}
            value={values.description}
            rows="4"
          />

          <input
            style={{ display: 'none' }}
            type="file"
            accept="image/*"
            ref={imgRef}
            onChange={(e) => handlePickImage(e)}
          />
          <div className={styles.image}>
            {productImage?.name || productImage ? (
              <div className="image_preview">
                <img
                  onClick={handleOpenImage}
                  src={
                    typeof productImage === 'string'
                      ? productImage
                      : URL.createObjectURL(productImage)
                  }
                  alt="selected"
                  className="object-cover w-full rounded-md min-h-40"
                />
              </div>
            ) : (
              <div
                className="grid place-items-center bg-gray-100 rounded-md cursor-pointer min-h-40 image_label"
                onClick={handleOpenImage}
              >
                Upload Image
              </div>
            )}
          </div>

          <button type="submit">
            {loading || creating ? 'Saving...' : 'Save Changes'}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default UpdateGroup;
